import { useEffect, useState } from "react";

type CustomVideoElem = HTMLVideoElement & {
    mozHasAudio?: boolean;
    webkitAudioDecodedByteCount?: number;
    audioTracks?: { length: number };
};

const hasAudio = (video: CustomVideoElem): boolean =>
    Boolean(
        video.mozHasAudio ||
            video.webkitAudioDecodedByteCount ||
            video.audioTracks?.length,
    );

const EVENTS = ["loadeddata", "loadedmetadata", "playing"] as const;

export const useDetectAudio = (video: HTMLVideoElement | null): boolean => {
    const [detected, setDetected] = useState(false);
    useEffect(() => {
        if (!video) {
            // eslint-disable-next-line react-hooks/set-state-in-effect -- reset detection for the next video; not a cascading render
            setDetected(false);
            return;
        }
        setDetected(false);
        const check = () => {
            if (hasAudio(video)) {
                setDetected(true);
                EVENTS.forEach((e) => video.removeEventListener(e, check));
            }
        };
        check();
        EVENTS.forEach((e) => video.addEventListener(e, check));
        return () => {
            EVENTS.forEach((e) => video.removeEventListener(e, check));
        };
    }, [video]);
    return detected;
};
